<template>
    <div>
 
 
        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <p class="is-size-5"> Status  </p>
                </div>
                <div class="level-item">
                    <p v-if="dataPARASpecLN.status.id < 5 "  class="is-size-5 has-text-info"> &nbsp; {{ dataPARASpecLN.status.name }}  </p>
                    <p v-if="dataPARASpecLN.status.id >=5 && dataPARASpecLN.status.id <=6"  class="is-size-5 has-text-success"> &nbsp; {{ dataPARASpecLN.status.name }}  </p>
                    <p v-if="dataPARASpecLN.status.id === 7 "  class="is-size-5 has-text-danger"> &nbsp; {{ dataPARASpecLN.status.name }} </p>
                </div>
                <div class="level-item">
                    <b-icon icon="lock" type="is-danger"  v-if="dataPARASpecLN.status.id >=5 "  ></b-icon>
                    <b-icon icon="lock-open" type="is-success"  v-if="dataPARASpecLN.status.id < 5 "  ></b-icon>
                </div>
                <div class="level-item">
                    <p class="is-size-5"> Assigned for </p>
                </div>
                <div class="level-item">
                    <p class="is-size-5 has-text-grey"> &nbsp; {{ dataPARASpecLN.assigned_to_user.name }}</p>
                </div>
                <div class="level-item">

                    <b-button type="is-success"
                              id="button_edit"
                              icon-left="pencil"
                              @click="showEditBact"
                              :disabled="!IDLABSelected.idlab "
                              v-if="
                                (
                                 (  ( dataPARASpecLN && (userRoleFind(3) || userRoleFind(4)  ))     )
                                 ||
                                    ( dataPARASpecLN && userIsAdmin )
                                 ||
                                  ( dataPARASpecLN && dataPARASpecLN.assigned_to_user.id === user_id )
                                 )  && dataPARASpecLN.status.id <=5

                                 ">
                        Edit
                    </b-button>

                </div>
                <div class="level-item">
                    <b-button type="is-primary  is-light" icon-left="file-pdf-box" :disabled="loadingReportFile" v-if="dataPARASpecLN.status.id >=5 && userRoleFind(6)" :loading="loadingReportFile" @click="reqReportFile(false,-1,[])" >View as Pdf(Text)</b-button>
                </div>
                <div class="level-item">
                    <b-button type="is-primary  is-light" icon-left="file-pdf-box"  v-if="dataPARASpecLN.status.id >=5 && userRoleFind(6)" :disabled="!dataPARASpecLN.display_title_image_for_nonadmin ||loadingImgReportFile "  :loading="loadingImgReportFile"  @click="reqImageReportFile">View as Pdf(Images)</b-button>
                </div>


            </div>
            <div class="level-right" v-if="( (dataPARASpecLN.assigned_to_user.id === user_id )||(userIsAdmin) )&& ( dataPARASpecLN.status.id >= 5 && dataPARASpecLN.status.id <= 6)">
                <div class="level-item">
                    <b-button type="is-danger"
                              icon-left="plus"
                              class="btn_plus"
                              @click="plusSomething">Plus
                    </b-button>
                </div>
                <div class="level-item">
                    <b-field
                            :type="{ 'is-danger': hasErrorPlusSomethingSelected}"
                            :message="{ 'pls select  ': hasErrorPlusSomethingSelected}">
                        <b-select placeholder="Select Plus Type" v-model="plusSomethingSelected">
                            <option value = 0> {{headerInfoPrepare}} </option>
                            <option value = 1> {{findingAndContent}} </option>
                            <option value = 2> {{images_title}} </option>
                            <option value = 3> {{ClassificationOfDiseases}} </option>
                            <option value = 4> {{ParasiteSelect}} </option>
                        </b-select>
                    </b-field>
                </div>
            </div>
        </nav>
        <hr>


        <div v-if="dataPARASpecLN && dataPARASpecLN.status.id >= 5 && dataPARASpecLN.status.id <=6 ">


            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
    

   <div class="container" v-if="displayTitle(dataPARASpecLN.dat_prepare.dat,dataPARASpecLN.data_plus.dat_prepare,dataPARASpecLN.display_title_prepare_for_nonadmin)  ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="headerPrepareInfo"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconFileDocument"
                           :visible = "true"/>
            </div>


          
  <!--     Prepare   ---------------------------------------------------------------------------------------------------->
 

            <!----------------------  Prepared   disPlayOrNot   dataPARASpecLN && dataPARASpecLN.dat_prepare.dat_txt.length>0  ------>
            <div class="container"  v-if="disPlayOrNot(dataPARASpecLN ,dataPARASpecLN.dat_prepare.dat_txt.length ,dataPARASpecLN.dat_prepare.visible )" >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="headerPrepareInfo"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataPARASpecLN.dat_prepare.visible "/>
                <div class="box"  >
                    <div  v-html="getDecodeFromBase64ToHtml( dataPARASpecLN.dat_prepare.dat )"
                          :style= "getStyleVisibleFalseInContent(dataPARASpecLN.dat_prepare.visible)" >
                    </div>
                </div>
                <FooterPlus  :user_rec="dataPARASpecLN.dat_prepare.user_rec"
                             :date_rec="dataPARASpecLN.dat_prepare.date_rec"
                             :time_rec="dataPARASpecLN.dat_prepare.time_rec"
                             :user_delete="dataPARASpecLN.dat_prepare.user_edit"
                             :date_delete="dataPARASpecLN.dat_prepare.date_edit"
                             :time_delete="dataPARASpecLN.dat_prepare.time_edit"
                             :userIsAdmin="userIsAdmin"
                             :idToDelete = "dataPARASpecLN.dat_prepare.id.toString()"
                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare"
                             :labKind = "IDLABSelected.kind"
                             :canDelete ="dataPARASpecLN.dat_prepare.visible"
                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
            </div>



            <!--           Prepare Plus  ------------------------------------------------------------------------------------------>
 
            <!----------------------- Prepare Plus  dataPARASpecLN && dataPARASpecLN.data_plus.dat_prepare.length>0 -->
            <div v-for="dat_prepare_plus in  dataPARASpecLN.data_plus.dat_prepare" :key="dat_prepare_plus.id">
                <div  class="container" v-if="disPlayOrNot(true,true,dat_prepare_plus.visible)">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="headerPrepareInfoPlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :visible = " dat_prepare_plus.visible "
                    />
                    <div class="box"  >
                        <div v-html="getDecodeFromBase64ToHtml(dat_prepare_plus.dat)"  :style= "getStyleVisibleFalseInContent(dat_prepare_plus.visible)">
                        </div>
                    </div>
                    <FooterPlus  :user_rec="dat_prepare_plus.user_rec"
                                 :date_rec="dat_prepare_plus.date_rec"
                                 :time_rec="dat_prepare_plus.time_rec"
                                 :user_delete="dat_prepare_plus.user_edit"
                                 :date_delete="dat_prepare_plus.date_edit"
                                 :time_delete="dat_prepare_plus.time_edit"
                                 :canDelete ="dat_prepare_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "dat_prepare_plus.id.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"
                    />
                </div>
            </div>










            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
 

            <div class="container" v-if="displayTitle(dataPARASpecLN.data_bact.length, dataPARASpecLN.data_plus.data , dataPARASpecLN.display_title_databact_for_nonadmin )">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="ParasiteSelect"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconFileDocument"
                           :visible = "true"/>
            </div>

            <!--          Main content Table UI for Result Bact -->
            <!-- <div class="container"  v-if="dataPARASpecLN && dataPARASpecLN.data_bact.length>0  " > -->
                <div class="container"  v-if="dataPARASpecLN && dataPARASpecLN.display_title_databact_for_nonadmin || userIsAdmin " >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="ParasiteSelect"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataPARASpecLN.data_bact.visible "
                />

                <template  v-for="(data_bact , index ) in dataPARASpecLN.data_bact">
                    <span :key="data_bact.idbact_uuid">
                          <div class="container box"   v-if="data_bact.visible ||userIsAdmin ">
                            <Each_PARA_Show
                                :data_each_bact =data_bact
                                :index = "index+1"
                                    
                             />
                  
                                <FooterPlus     v-if="data_bact.visible || userIsAdmin"
                                                :user_rec="data_bact.user_rec"
                                                :date_rec=" dateFromISOToFormat(data_bact.date_rec) "
                                                :time_rec=" timeFromISOToFormat(data_bact.time_rec)"
                                                :userIsAdmin="userIsAdmin"
                                                :user_delete="data_bact.user_edit"
                                                :date_delete="data_bact.date_edit"
                                                :time_delete="data_bact.time_edit"
                                                :canDelete ="data_bact.visible  ? true : false"
                                                :idToDelete = "data_bact.id.toString()"
                                                :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.bact_data"
                                                :labKind = "IDLABSelected.kind"
                                                @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                        
                         </div>
                    </span>
                </template>

             
            </div>
            <br>
 




            <!--          Main content Table UI for Result Bact Plus  -->
            <div v-for="data_bact_each_idtime in dataPARASpecLN.data_plus.data" :key="data_bact_each_idtime.idtime">
              <div class="container box "
                   v-if="disPlayOrNot(data_bact_each_idtime,
                                      data_bact_each_idtime.dat.length,
                                      data_bact_each_idtime.dat.length >0 ? data_bact_each_idtime.dat[0].visible : false)"
              >
                  <TitlePlus :datUserWhoView="getNameAndSurname"
                             :titleDisplay="ParasiteSelect"
                             :plus=false
                             :showIcon = false
                             :showTitleDisplay = false
                             :visible = "data_bact_each_idtime.visible"
                  />
                  <div    v-for="(data_bact_each_idtime_each_dat,index)  in data_bact_each_idtime.dat" :key="data_bact_each_idtime_each_dat.idbact_uuid" >
                      <Each_PARA_Show
                              :data_each_bact =data_bact_each_idtime_each_dat
                              :index="index+1"
                      />
                      <br>
                      
                      
                  </div>


              </div>
                <div class="container">
               <!-- test     {{data_bact_each_idtime.idtime}} -->
                     <FooterPlus
                            v-if="disPlayOrNot(data_bact_each_idtime,
                                      data_bact_each_idtime.dat.length,
                                      data_bact_each_idtime.dat.length >0 ? data_bact_each_idtime.dat[0].visible : false)"
                            :user_rec="data_bact_each_idtime.dat[0].user_rec_fn"
                            :date_rec="dateFromISOToFormat(dataPARASpecLN.dat_prepare.datetime_rec)  "
                            :time_rec="timeFromISOToFormat(dataPARASpecLN.dat_prepare.datetime_rec)  "
                            :user_delete="data_bact_each_idtime.dat[0].user_edit_fn === null  ? '' : data_bact_each_idtime.dat[0].user_edit_fn"
                            :date_delete="dateFromISOToFormat(data_bact_each_idtime.dat[0].date_edit)"
                            :time_delete="timeFromISOToFormat(data_bact_each_idtime.dat[0].time_edit)"
                            :canDelete ="data_bact_each_idtime.dat[0].visible"
                            :userIsAdmin="userIsAdmin"
                            :idToDelete = "data_bact_each_idtime.idtime.toString()"
                            :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.bact_data_plus"
                            :labKind = "IDLABSelected.kind"
                            @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>
                </div>

           </div>










            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
           <div class="container" v-if="displayTitle(dataPARASpecLN.dat_ct.dat_txt.length , dataPARASpecLN.data_plus.dat_ct , dataPARASpecLN.display_title_ct_for_nonadmin)">
            <TitlePlus :datUserWhoView="getNameAndSurname"
                       :titleDisplay="findingAndContent"
                       :plus=false
                       :showIcon = true
                       :showDatUserWhoView = "false"
                       :showTitleDisplay = true
                       :iconToShow = "iconFileDocument"
                       :visible = "true"/>
            </div>
            <!--     Findings and contents   -------------------------------------------------------------------------------------->
            <div class="container"  v-if="disPlayOrNot(dataPARASpecLN ,dataPARASpecLN.dat_ct.dat_txt.length ,dataPARASpecLN.dat_ct.visible )" >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="findingAndContent"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataPARASpecLN.dat_ct.visible "/>
                <div class="box"  >
                    <div  v-html="getDecodeFromBase64ToHtml( dataPARASpecLN.dat_ct.dat )"
                          :style= "getStyleVisibleFalseInContent(dataPARASpecLN.dat_ct.visible)" >
                    </div>
                </div>
                <FooterPlus  :user_rec="dataPARASpecLN.dat_ct.user_rec"
                             :date_rec="dataPARASpecLN.dat_ct.date_rec"
                             :time_rec="dataPARASpecLN.dat_ct.time_rec"
                             :user_delete="dataPARASpecLN.dat_ct.user_edit"
                             :date_delete="dataPARASpecLN.dat_ct.date_edit"
                             :time_delete="dataPARASpecLN.dat_ct.time_edit"
                             :userIsAdmin="userIsAdmin"
                             :idToDelete = "dataPARASpecLN.dat_ct.id.toString()"
                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare"
                             :labKind = "IDLABSelected.kind"
                             :canDelete ="dataPARASpecLN.dat_ct.visible"
                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
            </div>



            <!--           Content Plus  -->
            <!----------------------- Content Plus  -->
            <div v-for="dat_ct_plus in  dataPARASpecLN.data_plus.dat_ct" :key="dat_ct_plus.id_uuid">
                <div  class="container" v-if="disPlayOrNot(true,true,dat_ct_plus.visible)">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="headerPrepareInfoPlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :visible = " dat_ct_plus.visible "
                    />
                    <div class="box"  >
                        <div v-html="getDecodeFromBase64ToHtml(dat_ct_plus.dat)"  :style= "getStyleVisibleFalseInContent(dat_ct_plus.visible)" >
                        </div>
                    </div>

                    <FooterPlus  :user_rec="dat_ct_plus.user_rec"
                                 :date_rec="dat_ct_plus.date_rec"
                                 :time_rec="dat_ct_plus.time_rec"
                                 :user_delete="dat_ct_plus.user_edit"
                                 :date_delete="dat_ct_plus.date_edit"
                                 :time_delete="dat_ct_plus.time_edit"
                                 :canDelete ="dat_ct_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "dat_ct_plus.id.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"
                    />
                </div>
            </div>














            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <div  class="container"  v-if="displayTitle(dataPARASpecLN.img.dat , dataPARASpecLN.data_plus.img , dataPARASpecLN.display_title_image_for_nonadmin)    " >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="images_title"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconImage"
                           :visible = "true"/>
            </div>


            <!----------------------  Images  ------>
            <template v-if="disPlayOrNot(dataPARASpecLN ,dataPARASpecLN.img.dat.length ,
                                         dataPARASpecLN.img.dat.length>0 ? dataPARASpecLN.img.dat[0].visible : false  )">
                <div class="container"  v-if="dataPARASpecLN && dataPARASpecLN.img.dat.length>0 " >
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="images_title"
                               :plus=false
                               :showDatUserWhoView = true
                               :showIcon = false
                               :showTitleDisplay = false
                    />



                    <ThumbnailImageList  v-if="dataPassThruImageList.length>0"
                                         :modeThumbnailImageList="modeThumbnailImageList"
                                         :dataPassThruImageList="dataPassThruImageList"
                                         :plus="false"/>


                    <FooterPlus  :user_rec="dataPARASpecLN.img.user_rec"
                                 :date_rec="dataPARASpecLN.img.date_rec"
                                 :time_rec="dataPARASpecLN.img.time_rec"
                                 :user_delete="dataPARASpecLN.img.user_edit"
                                 :date_delete="dataPARASpecLN.img.date_edit"
                                 :time_delete="dataPARASpecLN.img.time_edit"
                                 :canDelete ="dataPARASpecLN.img.user_edit.length>0 ? false : true"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "IDLABSelected.idlab"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                </div>

            </template>





            <!--           Image Plus  --------------------------------------------------------------------------------------------->
            <div  class="container"  v-for=" img in dataPARASpecLN.data_plus.img" :key="img.idtime">

                <template v-if="disPlayOrNot(true,true,img.visible[0])">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="ImagePlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :showDatUserWhoView = true
                    />
                    <br>
                    <ThumbnailImageList    :modeThumbnailImageList="modeThumbnailImageList" :dataPassThruImageList="dataPassThruImageListPlus(img.idtime)"  :plus="true"  />
                    <FooterPlus  :user_rec="getUserRecImgPlusByIdTime(img.idtime)"
                                 :date_rec="getDateRecImgPlusByIdTime(img.idtime)"
                                 :time_rec="getTimeRecImgPlusByIdTime(img.idtime)"
                                 :user_delete="img.user_edit.length>0 ? img.user_edit[0] : '' "
                                 :date_delete="img.date_edit.length>0 ? img.date_edit[0] : '' "
                                 :time_delete="img.time_edit.length>0 ? img.time_edit[0] : ''"
                                 :canDelete ="img.visible.length>0 ? img.visible[0] : false"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "img.idtime.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                    <br>
                </template>
            </div>








            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <div  class="container" v-if=" displayTitle( dataPARASpecLN.diag_code.dat , dataPARASpecLN.data_plus.diag_code ,dataPARASpecLN.display_title_diag_for_nonadmin )  ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="ClassificationOfDiseases"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconDx"
                           :visible = "true"/>
            </div>


            <!----------------------  Diagosis  ---------------------------------------------------------------------------------->
            <template v-if="disPlayOrNot(dataPARASpecLN ,dataPARASpecLN.diag_code.dat.length ,
                                         dataPARASpecLN.diag_code.dat.length>0 ? dataPARASpecLN.diag_code.dat[0].visible : false  )">
                <div class="container"  v-if="dataPARASpecLN && dataPARASpecLN.diag_code.dat.length>0" >
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="ClassificationOfDiseases"
                               :plus=false
                               :showIcon = false
                               :showDatUserWhoView = "true"
                               :showTitleDisplay = false
                    />
                    <b-table             :data="isEmpty ? [] : dataPARASpecLN.diag_code.dat "
                                         bordered
                                         striped
                                         narrowed
                                         hoverable
                                         focusable
                                         mobile-cards
                    >


                        <b-table-column field="level1Name" label="Chapter" v-slot="props">
                            {{ props.row.level1Name }}
                        </b-table-column>

                        <b-table-column field="level2Name" label="Body System" v-slot="props">
                            {{ props.row.level2Name }}
                        </b-table-column>

                        <b-table-column field="level3Name" label="Organ/Tissue" v-slot="props">
                            {{ props.row.level3Name }}
                        </b-table-column>

                        <b-table-column field="level4Name" label="Character/Subcategories" v-slot="props">
                            {{ props.row.level4Name }}
                        </b-table-column>

                        <b-table-column field="level5Name" label="Extensions" v-slot="props">
                            {{ props.row.level5Name }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="Unclassified Descriptions" v-slot="props">
                            {{ props.row.unClassifiedCodes }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="%" v-slot="props">
                            {{ props.row.labDiseasecodeAccurateName }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="Comment"  v-slot="props">
                            {{ props.row.comment }}
                        </b-table-column>

                    </b-table>
                    <FooterPlus  :user_rec="dataPARASpecLN.diag_code.user_rec"
                                 :date_rec="dataPARASpecLN.diag_code.date_rec"
                                 :time_rec="dataPARASpecLN.diag_code.time_rec"

                                 :user_delete="dataPARASpecLN.diag_code.user_edit"
                                 :date_delete="dataPARASpecLN.diag_code.date_edit"
                                 :time_delete="dataPARASpecLN.diag_code.time_edit"
                                 :canDelete ="dataPARASpecLN.diag_code.user_edit.length>0 ? false : true"

                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "IDLABSelected.idlab"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>
                    <br>
                </div>

            </template>




            <!----------------------         Diagosis Plus   dataCytoSpecLN.data_plus.diag_code  v-if="dataCytoSpecLN.data_plus.diag_code.length>0"-->
            <div  class="container"  v-for=" diag_code_plus in dataPARASpecLN.data_plus.diag_code" :key="diag_code_plus.idtime">
                <template v-if="disPlayOrNot(true,true,diag_code_plus.visible)">



                    <TitlePlus
                            :datUserWhoView="getNameAndSurname"
                            :titleDisplay="ClassificationOfDiseases"
                            :plus=true
                            :showIcon = false
                            :showTitleDisplay = false
                            :showDatUserWhoView = true
                    />
                    <b-table         :data="diag_code_plus.dat"
                                     bordered
                                     striped
                                     narrowed
                                     hoverable
                                     focusable
                                     mobile-cards
                    >
                        <b-table-column   label="Chapter" v-slot="props">
                            {{ props.row.level1Name }}
                        </b-table-column>
                        <b-table-column   label="Body System" v-slot="props">
                            {{ props.row.level2Name }}
                        </b-table-column>
                        <b-table-column   label="Organ/Tissue" v-slot="props">
                            {{ props.row.level3Name }}
                        </b-table-column>
                        <b-table-column   label="Character/Subcategories" v-slot="props">
                            {{ props.row.level4Name }}
                        </b-table-column>
                        <b-table-column   label="Extensions" v-slot="props">
                            {{ props.row.level5Name }}
                        </b-table-column>
                        <b-table-column  label="Unclassified Descriptions" v-slot="props">
                            {{ props.row.unClassifiedCodes }}
                        </b-table-column>
                        <b-table-column  label="%" v-slot="props">
                            {{ props.row.labDiseasecodeAccurateName }}
                        </b-table-column>
                        <b-table-column  label="Remark" v-slot="props">
                            {{ props.row.comment }}
                        </b-table-column>

                    </b-table>

                    <FooterPlus  :user_rec="diag_code_plus.dat[0].user_rec"
                                 :date_rec="diag_code_plus.dat[0].date_rec"
                                 :time_rec="diag_code_plus.dat[0].time_rec"
                                 :user_delete="diag_code_plus.dat[0].user_edit.length>0 ? diag_code_plus.dat[0].user_edit : '' "
                                 :date_delete="diag_code_plus.dat[0].date_edit.length>0 ? diag_code_plus.dat[0].date_edit : '' "
                                 :time_delete="diag_code_plus.dat[0].time_edit.length>0 ? diag_code_plus.dat[0].time_edit : '' "
                                 :canDelete ="diag_code_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "diag_code_plus.idtime.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />

                </template>
            </div>


 
            <br>
            <!---------------- Display Title if normal or plus existing  -->
            <div  class="container"  v-if="  dataPARASpecLN ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="RequestedInfo"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconInfoRequest"
                           :visible = "true"/>
            </div>
            <!-----------------     Request Info.  ----------------->
            <div class="container"  v-if="dataPARASpecLN" >
                <TitlePlus
                        :datUserWhoView="getNameAndSurname"
                        :titleDisplay="RequestedInfo"
                        :plus=false
                        :showIcon = false
                        :showTitleDisplay = false
                        :showDatUserWhoView = true
                />
                <FooterRequest :dataReqToFooter="dataPARASpecLN.data_req"/>
            </div>



          


        <!--   end of  >>>>>>   <div v-if="dataPARASpecLN && dataPARASpecLN.status.id >= 5 && dataPARASpecLN.status.id <=6 ">          -->
        </div>

        <PlusEditor   v-if="isPlusEditor"
                      :isShowing="isPlusEditor"
                      :idlab="IDLABSelected.idlab"
                      :labKind="IDLABSelected.kind"
                      :submitTypePlusEdit="submitTypePlusEditTmp"
                      @close="closePlusEditor"
                      @closeWithChange="closePlusEditorWithChange" />


        <PlusImages  v-if="isPlusImages"
                     :isShowing="isPlusImages"
                     :idlab="IDLABSelected.idlab"
                     @closePlusImagesWithData="closePlusImagesWithData"
                     @closePlusImages="closePlusImages"/>


        <PlusSelectDiseaseCode v-if="isPlusSelectDiseaseCode"
                               :idlab="IDLABSelected.idlab"
                               :isShowing="isPlusSelectDiseaseCode"
                               @closePlusSelectDiseaseCode_WithChange = "closePlusSelectDiseaseCode_WithChange"
                               @closePlusSelectDiseaseCode="closePlusSelectDiseaseCode"/>


        <PlusParasite  v-if="isPlusParasite"
                       :idlab="IDLABSelected.idlab"
                       :isShowing="isPlusParasite"
                       @closePlusParasite_WithChange = "closePlusParasite_WithChange"
                       @closePlusParasite = "closePlusParasite"/>



        <EditDocLabBact
                ref="EditDocLabBact"
                :isComponentModalActive="isBACTEditorShowing"
                :IDLABSelected="IDLABSelected"
                @close="closeEditDocLabBact"
        />


        <b-modal
                v-model="isSelectImgForMakePdf"
                has-modal-card
                full-screen
                :can-cancel="true">
            <SelectImgForMakePdf
                    :arrImg = "arrPropsToImgReport"
                    @closeSelectImgForMakePdfWithDataWantTo="doReqImageReportFile"
                    @closeSelectImgForMakePdf="closeSelectImgForMakePdf"/>
        </b-modal>






    </div>
</template>

<script>
    /* eslint-disable */
    import { genUUID , getBaseURLAvartar , DATA_PARA_LN_MODEL } from '@/utils.js'
    import userRoleFind from "../../mixins/methods/userRoleFind";
    import {mapState} from "vuex";
    import TitlePlus from "./Plus/TitlePlus";
    import getISO8601ToYearMonthDate from "../../mixins/methods/getISO8601ToYearMonthDate";
    import globalconst from "../../mixins/globalconst";
    import getDecodeFromBase64ToHtml from "../../mixins/methods/getDecodeFromBase64ToHtml";
    import FooterPlus from "./Plus/FooterPlus";
    import ThumbnailImageList from "../UtilsComponents/ThumbnailImageList";
    import FooterRequest from "./FooterRequest";
    import Each_PARA_Show from "./Parasite/Each_PARA_Show";
    import EditDocLabBact from "./EditDocLabBact";
    import PlusEditor from "./Plus/PlusEditor";
    import PlusImages from "./Plus/PlusImages";
    import PlusSelectDiseaseCode from "./Plus/PlusSelectDiseaseCode";
    import PlusParasite from "./Plus/PlusParasite";
    import disPlayOrNot from "../../mixins/methods/disPlayOrNot";
    import getStyleVisibleFalseInContent from "../../mixins/methods/getStyleVisibleFalseInContent";
    import iconTitle from "../../mixins/data/iconTitle";
    import doReportFile from "../../mixins/methods/doReportFile";
    import selectURL_NextFrom_DoReportFile_ByCallFrmVar from "../../mixins/methods/selectURL_NextFrom_DoReportFile_ByCallFrmVar";
    import displayTitle from "../../mixins/methods/displayTitle";
    import FileSaver from "file-saver";

    import SelectImgForMakePdf from "./SelectImgForMakePdf/SelectImgForMakePdf";
    import {DateTime} from "luxon";
    import timeFromISOToFormat from "../../mixins/methods/timeFromISOToFormat";
    import dateFromISOToFormat from "../../mixins/methods/dateFromISOToFormat";

    export default {
        name: "PARA_EachID",
        props:{
            dataPARASpecLN : DATA_PARA_LN_MODEL,
            IDLABSelected: null ,
        },
        components:{
            TitlePlus,
            FooterPlus,
            ThumbnailImageList,
            FooterRequest,
            Each_PARA_Show,
            EditDocLabBact,
            PlusEditor,
            PlusImages,
            PlusSelectDiseaseCode,
            PlusParasite,
            SelectImgForMakePdf
        },
        mixins:[getStyleVisibleFalseInContent,disPlayOrNot,
                userRoleFind,getISO8601ToYearMonthDate,
                globalconst,getDecodeFromBase64ToHtml,
                iconTitle,doReportFile,selectURL_NextFrom_DoReportFile_ByCallFrmVar,displayTitle,
                timeFromISOToFormat , dateFromISOToFormat],
        computed: {
            ...mapState({
                user_id: state => state.master_data.user_id,
                user_role: state => state.master_data.user_role,
                userIsAdmin: state => state.master_data.userIsAdmin,
                clientIP: state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            }),
            getNameAndSurname: function(){
                const userFullName = localStorage.getItem('user_name_surname')

                return  `<p class="has-text-weight-light has-text-grey-lighter" style="color: #00b89c; padding-top: 15px">
                         View by ${userFullName}
                          ${this.getISO8601ToYearMonthDate(this.dataPARASpecLN.current_datetime).date}
                          ${this.getISO8601ToYearMonthDate(this.dataPARASpecLN.current_datetime).month}
                          ${this.getISO8601ToYearMonthDate(this.dataPARASpecLN.current_datetime).year}
                          <i>
                          (
                          ${this.getISO8601ToYearMonthDate(this.dataPARASpecLN.current_datetime).hour}
                          :
                          ${this.getISO8601ToYearMonthDate(this.dataPARASpecLN.current_datetime).minute}
                          )
                          </i>
                          </p>`
                // return localStorage.getItem('user_name_surname')
            },
            dataPassThruImageList: function () {
                // [ { id: tmpID ,
                //     file : null,
                //     urlTempUploaded: tmpUrl,
                //     title : vm.dataAllContent.img.dat[i].title,
                //     fileNameUploaded:  vm.dataAllContent.img.dat[i].file ,
                //     fresh : false  } ]
                if(this.dataPARASpecLN.img.dat.length>0) {
                    return this.dataPARASpecLN.img.dat.map(dat => {
                        return {
                            id: genUUID(5),
                            file: null,
                            urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                            title: dat.title,
                            fileNameUploaded: dat.file,
                            fresh: false
                        }
                    })
                }else{
                    return []
                }
            }
        },
        methods:{
            // dateFromISOToFormat(_datDate){
            //     return  DateTime.fromISO(_datDate).toFormat('DD');
            // },
            // timeFromISOToFormat(_datTime){
            //     return  DateTime.fromISO(_datTime ).toFormat('T');
            // },

            closeSelectImgForMakePdf(){
                this.isSelectImgForMakePdf = false
            },

            reqImageReportFile(){
                if  (this.dataPARASpecLN.display_title_image_for_nonadmin){
                    // build arr
                    // {"id":1  , "descp": "lorem","select": true,"url": "http://127.0.0.1:5000/static/uploads/64BIOP0000000155/179452040286.jpg"}
                    // `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                    this.arrPropsToImgReport = []
                    //genUUID
                    this.dataPARASpecLN.img.dat.forEach(dat=>{
                        if (dat.visible){
                            this.arrPropsToImgReport.push(   {"id":genUUID(5)  , "descp": "", "select": false,"url": `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}` , "file": dat.file }  )
                        }
                    })
                    //
                    for(var i =0 ; i<this.dataPARASpecLN.data_plus.img.length;i++){
                        for(var j =0; j < this.dataPARASpecLN.data_plus.img[i].visible.length ; j++){
                            if (this.dataPARASpecLN.data_plus.img[i].visible[j]){
                                this.arrPropsToImgReport.push(
                                    {"id":genUUID(5)  , "descp": "", "select": false,
                                        "url": `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${this.dataPARASpecLN.data_plus.img[i].file[j]}` ,
                                        "file": this.dataPARASpecLN.data_plus.img[i].file[j]
                                    }
                                )
                            }
                        }

                    }


                    if ( this.arrPropsToImgReport.length >0 ){
                        this.isSelectImgForMakePdf = true
                    }else{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Nothing Images`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    }



                }

            },


            doReqImageReportFile(payload){
                this.isSelectImgForMakePdf = false
                var arr_img_data_want = []
                for(var i=0;i<payload.arrImg.length;i++){
                   if (payload.arrImg[i].select){
                       arr_img_data_want.push(payload.arrImg[i].file)
                   }
                }


                this.reqReportFile(true,parseInt( payload.num_of_col ) ,arr_img_data_want)


            },

            reqReportFile(pure_Img,col_if_pure_img,arr_img_data_want){
                if(pure_Img){
                    this.loadingImgReportFile = true
                }else{
                    this.loadingReportFile = true
                }

                this.doReportFile(this.IDLABSelected,this.clientIP,pure_Img,col_if_pure_img,arr_img_data_want)
                    .then(res=>{
                        FileSaver.saveAs(this.selectURL_NextFrom_DoReportFile_ByCallFrmVar(res), `${res.file_name}.pdf`);
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
                    .catch(err=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.response.data.msg}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
                    .finally(()=>{
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
            },











            closePlusSelectDiseaseCode(){
                this.isPlusSelectDiseaseCode = false
            },
            closePlusSelectDiseaseCode_WithChange(){
                // console.log('closePlusSelectDiseaseCode_WithChange')
                this.$emit('trigForPlusUpdate')
                this.isPlusSelectDiseaseCode = false
            },
            closePlusImagesWithData(){
                this.isPlusImages = false
                this.$emit('trigForPlusUpdate')
            },
            closePlusImages(){
                this.isPlusImages = false
            },
            closePlusEditor(){
                this.isPlusEditor = false
            },
            closePlusEditorWithChange(){
                this.$emit('trigForPlusUpdate')
                this.isPlusEditor = false
            },
            closeEditDocLabBact(){
                this.isBACTEditorShowing = false
            },
            showEditBact(){

                // this.$refs.EditDocLabPCR.loadOldDat()
                // this.$refs.EditDocLabPCR.isComponentModalActive = true
                //
                this.isBACTEditorShowing = true

            },
            showPlusImages(){
                this.isPlusImages = true
            },
            showPlusEditor(_type){
                this.submitTypePlusEditTmp = _type
                this.isPlusEditor = true
            },
            plusSomething(){
                if(this.plusSomethingSelected === null){
                    this.hasErrorPlusSomethingSelected = true
                    return
                }


                if(this.plusSomethingSelected  == 0){
                    this.showPlusEditor(this.SUBMIT_TYPE_PLUS_EDIT.prepare)
                }else if (this.plusSomethingSelected  == 1){
                    this.showPlusEditor(this.SUBMIT_TYPE_PLUS_EDIT.ct)
                }else if (this.plusSomethingSelected  == 2){
                    this.showPlusImages()
                }else if (this.plusSomethingSelected  == 3){
                    this.addPlusSelectDiseaseCode()
                }else if (this.plusSomethingSelected  == 4){
                    this.addPlusParasite()
                }else {
                    return
                }
            },
            closePlusParasite_WithChange(){
                this.isPlusParasite = false
                this.$emit('trigForPlusUpdate')
            },
            closePlusParasite(){
                this.isPlusParasite = false
            },
            addPlusParasite(){
                this.isPlusParasite = true
            },
            addPlusSelectDiseaseCode(){
                this.isPlusSelectDiseaseCode = true
            },
            footerPlusWithChangeDisable(){
                this.$emit('trigForPlusUpdate')
            },
            getTimeRecImgPlusByIdTime(_idtime){
                const member  = this.dataPARASpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.time_rec[0]
            },
            getDateRecImgPlusByIdTime(_idtime){
                const member  = this.dataPARASpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.date_rec[0]
            },
            getUserRecImgPlusByIdTime(_idtime){
                const member  = this.dataPARASpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.user_rec[0]
            },
            dataPassThruImageListPlus(_idtime) {
                if(this.dataPARASpecLN.data_plus.img.length>0) {
                    const member = this.dataPARASpecLN.data_plus.img.find(data => data.idtime === _idtime)
                    var tmpArr = []
                    for (var i = 0; i <= member.id.length - 1; i++) {
                        const tmp = {
                            id: member.id[i],
                            file: null,
                            urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${member.file[i]}`,
                            title: member.title[i],
                            fileNameUploaded: member.file[i],
                            fresh: false
                        }
                        tmpArr.push(tmp)
                    }
                    return tmpArr
                }else{
                    return []
                }
            }
        },
        data(){
            return {
                hasErrorPlusSomethingSelected : false ,
                plusSomethingSelected : null,
                isBACTEditorShowing : false,

                modeThumbnailImageList : "view",
                submitTypePlusEditTmp : "",
                isPlusSelectDiseaseCode : false,
                isPlusImages : false,
                isPlusEditor : false,
                isPlusParasite : false,

                isEmpty : false,


                isSelectImgForMakePdf : false,
                arrPropsToImgReport : []

            }
        },
        watch:{
            plusSomethingSelected :{
                immediate : true,
                handler : function (val) {
                    if(val !== null){
                        this.hasErrorPlusSomethingSelected = false
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>